import _, { toInteger } from 'lodash';
import {
    SgDateUtil,
    SgNumberUtil,
    CommonAdobeAnalyticsUtil,
    SptAdobeAnalyticsUtil
} from 'saga-modules';
import SgSptConstants from 'sg-spt-constants';

const SPT_TAGGING_PROPERTIES = {
    SgSptTripProductTypeTileButtons: {
        id: 'coverType',
        transform: (value) => {
            return SptAdobeAnalyticsUtil.transformCoverTypeValue(value);
        }
    },
    departureDate: {
        id: 'outboundDate',
        transform: (date) => ((date.day && date.monthViewValue && date.year)
            // dd/MM/yyyy
            ? `${SgNumberUtil.add0Padding(date.day)}/${SgNumberUtil.add0Padding(date.monthViewValue)}/${date.year}`
            : undefined),
        dependent: ['numberOfDaysTillTravelStart']
    },
    returnDate: {
        id: 'returnDate',
        transform: (date) => ((date.day && date.monthViewValue && date.year)
            // dd/MM/yyyy
            ? `${SgNumberUtil.add0Padding(date.day)}/${SgNumberUtil.add0Padding(date.monthViewValue)}/${date.year}`
            : undefined)
    },
    numberOfDaysTillTravelStart: {
        id: 'numberOfDaysTillTravelStart',
        getValue: (source) => (_.isObject(source) && !_.isEmpty(source) && SgDateUtil.dateIsValid(source)
            ? SgDateUtil.dateDiffInDays(new Date(), source).toString() : undefined)
    },
    duration: {
        id: 'duration',
        transform: (value) => toInteger(value)
    },
    destination: {
        id: 'destination',
        transform: (value) => {
            return SptAdobeAnalyticsUtil.formatSingleTripDestinationValue(value);
        }
    },
    SgSptTripDestinationAnnualRegion: {
        id: 'region',
        transform: (value) => {
            return SptAdobeAnalyticsUtil.formatRegionValue(value);
        }
    },
    tripBooked: { id: 'tripBooked' },
    tripType: {
        id: 'tripType',
        transform: (value) => {
            return SptAdobeAnalyticsUtil.formatActivityTypeValue(value);
        }
    },
    excessSingle: {
        id: 'tripExcess',
        transform: (value) => {
            return value.code.split('_')[0];
        }
    },
    excessAnnual: {
        id: 'tripExcess',
        transform: (value) => {
            return value.code.split('_')[0];
        }
    },
    cancellationCoverRequired: { id: 'cancellationCoverRequired' },
    cancellationCoverTripValueKnown: { id: 'cancellationAmountKnown' },
    tripTotalCost: {
        id: 'cancelCoverAmount',
        transform: (value) => {
            if (!value.amount) {
                return undefined;
            }
            return _.isString(value.amount) ? toInteger(value.amount.replace(',', '')) : value.amount;
        }
    },
    cancellationValueBrackets: {
        id: 'cancelCoverAmount',
        transform: (value) => {
            if (value.code) {
                return value.code === SgSptConstants.TRIP_CANCELLATION_VALUE_BRACKETS.OVER_15000 ? 15001 : toInteger(value.code.split('_').pop());
            }
            return '';
        }
    },
    isUsa: { id: 'specificWorldwideRegions' },
    tripExtensionLength: {
        id: 'extendedTripLimit',
        transform: (value) => {
            return CommonAdobeAnalyticsUtil.getTypelistValue('SPTTripExtensionOption', value).split(' ')[0];
        }
    },
    hadAdditionalTravellers: { id: 'additionalTraveller' },
    travellerNumber: {
        id: 'travellerNumber',
        transform: (value) => {
            return value.length.toString();
        },
        dependent: ['additionalTravellerTitle']
    },
    additionalTravellerTitle: {
        id: 'additionalTravellerTitle',
        getValue: (source) => {
            return SptAdobeAnalyticsUtil.formatAdditionalTravellerTitleValue(source);
        }
    },
    winterSportTrip: {
        id: 'winterSportTrip',
        transform: (value) => {
            return SptAdobeAnalyticsUtil.formatWinterSportsValue(value);
        }
    },
    holidayHome: { id: 'holidayHomeOwnership' },
    hasSelfPrivateHealthCover: { id: 'PMIOwnership' },
    sourceOfBusiness: {
        id: 'whatBroughtYouToSaga',
        transform: (value) => {
            return value.code ? CommonAdobeAnalyticsUtil.getTypelistValue('SourceOfBusiness_Ext', value.code) : undefined;
        }
    },
    upgradeOffered: {
        id: 'upgradeOffered',
        transform: (value) => {
            return SptAdobeAnalyticsUtil.trackUpgradeOfferedValue(value);
        }
    },
    quoteStep: { id: 'quoteStep' },
    quoteStart: { id: 'quoteStart' },
    quoteComplete: { id: 'quoteComplete' },
    medicalQuestionHasRecentIllnesses: { id: 'twelveM' },
    medicalQuestionHasSeriousConditions: { id: 'HCT' },
    medicalQuestionIsTakingMedication: { id: 'MEDS' },
    materialFactsQuestionIsInvestigated: { id: 'AMT' },
    materialFactsQuestionIsTerminalDiagnosisOrTravelAgainstAdvice: { id: 'TAD' },
    materialFactsQuestionIsWaitingList: { id: 'WLT' },
    materialFactsQuestionIsDiagnosedIssueWaitingList: { id: 'DC' },
    product: {
        id: 'product',
        transform: (value) => SptAdobeAnalyticsUtil.formatProduct(value),
    },
    totalSinglePremiumCost: {
        id: 'totalSinglePremiumCost',
        transform: (value) => SptAdobeAnalyticsUtil.formatSelectedCoverLevelPremium(value, false)
    },
    totalAnnualPremiumCost: {
        id: 'totalAnnualPremiumCost',
        transform: (value) => SptAdobeAnalyticsUtil.formatSelectedCoverLevelPremium(value, true)
    },
    priceDifference: {
        id: 'priceDifference',
        transform: (value) => SptAdobeAnalyticsUtil.formatPriceDifferences(value)
    }
};

export default SPT_TAGGING_PROPERTIES;
